import { Box, Heading, HStack, Icon, Text, VStack } from "@chakra-ui/react";

import { IoMdRefresh } from "react-icons/io";

import { useCommunicationQueries } from "@/hooks/features/useCommunicationQueries";

const QueriesOverviewInfoBox = ({
  title,
  description
}: {
  title: string;
  description: string;
}) => (
  <Box
    border="solid lightGray 1px"
    borderRadius={6}
    py={3}
    px={5}
    width="30%"
    backgroundColor="white"
    display="flex"
    flexDirection="column"
  >
    <VStack justifyContent="center" alignItems="flex-start" gap={0} flex={1}>
      <Text fontWeight="semibold" fontSize={13}>
        {title}
      </Text>
      <Text fontWeight="bold" fontSize={20}>
        {description}
      </Text>
    </VStack>
  </Box>
);

export const QueriesOverview = ({
  context
}: {
  context: "company" | "client";
}) => {
  const { dispatchLoadQueries, timeLastRefreshed, queries } =
    useCommunicationQueries(context);

  return (
    <Box mb={8}>
      <Heading color="secondary.600" fontSize={36} fontWeight={600} mb={10}>
        Overview
      </Heading>
      <HStack justifyContent="space-between" alignItems="space-between">
        <HStack gap={7} align="stretch" width="75%">
          <QueriesOverviewInfoBox 
            title="TOTAL QUERIES" 
            description={queries?.total?.toString() || '0'} 
          />
          <QueriesOverviewInfoBox 
            title="OPEN" 
            description={(
              (queries?.total || 0) - 
              ((queries?.status_counts?.RESOLVED || 0) + (queries?.status_counts?.MISSING_INVOICES || 0))
            ).toString()} 
          />
          <QueriesOverviewInfoBox 
            title="RESOLVED" 
            description={queries?.status_counts?.RESOLVED?.toString() || '0'} 
          />
        </HStack>
        <VStack alignItems="flex-end" justifyContent="flex-end">
          <Icon
            as={IoMdRefresh}
            color="black"
            bg="white"
            borderRadius="full"
            boxSize={8}
            p={2}
            onClick={() => {
              dispatchLoadQueries();
            }}
            cursor="pointer"
          />
          <Text fontSize={10} fontStyle="italic">
            Last updated {timeLastRefreshed}
          </Text>
        </VStack>
      </HStack>
    </Box>
  );
};
